class MarqueeComponent extends HTMLElement {
  connectedCallback() {
    const wrapper = this.querySelector(".marquee__wrapper");
    const content = this.querySelector(".marquee__content");
    const repeatedItems = content?.querySelector(".marquee__repeated-items");

    // ✅ Duplicate items for seamless scrolling (only once)
    if (repeatedItems && content.querySelectorAll(".marquee__repeated-items").length < 2) {
      const clone = repeatedItems.cloneNode(true);
      content.appendChild(clone);
    }

    // Get speeds from data attributes
    const desktopSpeed = this.dataset.speedDesktop || 20;
    const mobileSpeed = this.dataset.speedMobile || 30;

    // Pick correct speed based on screen size
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    const speed = isMobile ? mobileSpeed : desktopSpeed;

    wrapper.style.setProperty("--marquee-speed", `${speed}s`);
  }
}

customElements.define("marquee-component", MarqueeComponent);
